import React, { useCallback, useEffect, useState } from 'react';
import Cropper from 'react-easy-crop';
import './ImageCropModal.css';

const ImageCropModal = ({
    open,
    imageSrc,
    aspect = 1,
    onCancel,
    onConfirm,
    confirmLabel = 'Save Crop',
    loading = false,
    error = '',
}) => {
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

    useEffect(() => {
        if (open) {
            setCrop({ x: 0, y: 0 });
            setZoom(1);
            setCroppedAreaPixels(null);
        }
    }, [open, imageSrc]);

    const handleCropComplete = useCallback((_, croppedPixels) => {
        setCroppedAreaPixels(croppedPixels);
    }, []);

    const handleConfirm = useCallback(() => {
        if (!croppedAreaPixels || !onConfirm) {
            return;
        }
        onConfirm(croppedAreaPixels);
    }, [croppedAreaPixels, onConfirm]);

    if (!open || !imageSrc) {
        return null;
    }

    return (
        <div className="image-crop-modal">
            <div className="image-crop-modal__content">
                <div className="image-crop-modal__cropper">
                    <Cropper
                        image={imageSrc}
                        crop={crop}
                        zoom={zoom}
                        aspect={aspect}
                        cropShape="rect"
                        showGrid={false}
                        onCropChange={setCrop}
                        onZoomChange={setZoom}
                        onCropComplete={handleCropComplete}
                    />
                </div>
                <div className="image-crop-modal__controls">
                    <label className="image-crop-modal__zoom">
                        <span>Zoom</span>
                        <input
                            type="range"
                            min="1"
                            max="3"
                            step="0.1"
                            value={zoom}
                            onChange={(event) => setZoom(Number(event.target.value))}
                        />
                    </label>
                    {error && (
                        <p className="image-crop-modal__error" role="alert">{error}</p>
                    )}
                    <div className="image-crop-modal__actions">
                        <button
                            type="button"
                            className="image-crop-modal__button cancel"
                            onClick={onCancel}
                            disabled={loading}
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            className="image-crop-modal__button confirm"
                            onClick={handleConfirm}
                            disabled={loading || !croppedAreaPixels}
                        >
                            {loading ? 'Saving…' : confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ImageCropModal;
